/* eslint no-console:0 */
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { UploadOutlined } from '@ant-design/icons';
import { Button, Upload, message, Tooltip } from 'antd';
import NavHeader from './../components/header/Header';
import JSON from 'JSON';
import logo from '../pig512.png';
import './draggerFiles.scss';

const { Dragger } = Upload;

// var urlUp = "http://160.251.120.163:5000/files/upload";
// var urlDown = "http://160.251.120.163:5000/files/download";
// var urlTest = "http://160.251.120.163:5000/test";
var fileInstance = axios.create({
  baseURL: 'http://160.251.120.163:5000',
  headers: { "Content-Type": "multipart/form-data" }
});

export default function DraggerFiles(props) {
  const [fileList, setFileList] = useState([]);
  const [uploading, setUploading] = useState(false);
  let navigate = useNavigate();
  //string to Json
  function stringToJson(data) {
    return JSON.parse(data);
  }
  function UploadFile(file) {
    var formData = new FormData();
    fileList.forEach(function (file) {
      formData.append('uploads', file);
      console.log(formData.getAll('uploads'));
    })
    setUploading(true);
    fileInstance.post('/files/upload', formData).then(function (res) {
      if (res.status === 200) {
        setUploading(false);
        console.log('res.data', res.data);
        const { table: table1, files, info } = res.data;
        if (!table1 || info) {
          message.error(info);
          return;
        }
        const table = table1 ? stringToJson(table1) : [];
        const index = table["index"];
        console.log(index.length)
        console.log('table=', table);
        const columnsData = table.columns;
        const tableData = table.data;
        const columns = columnsData && columnsData.map((val, index) => {
          return {
            title: val,
            dataIndex: val,
            ellipsis: true,
            fixed: index === 0 ? 'left' : false,
            width: index === 0 ? 260 : 120,
          }
        })
        let dataSource = [];
        const columnsDataLen = columnsData.length;
        for (let i = 0; i < index.length; i++) {
          const data = {};
          for (let j = 0; j < columnsDataLen; j++) {
            data[columnsData[j]] = tableData[i][j] || '--';
          }
          data["key"] = i;
          console.log(data)
          dataSource.push(data)
        }
        files.forEach((fileName, index) => {
          const dataItem = dataSource[index];
          dataItem && (dataItem.fileName = fileName || '--');
        })
        navigate("/uploadfilesAlysisResult", {
          state: {
            columns,
            dataSource,
            pagination: false,
            scroll: {
              x: (columns.length - 1) * 120 + 260,
              y: 500,
              scrollToFirstRowOnChange: true
            }
          }
        })
      }
    });
  }

  const uploadProps = {
    multiple: true,
    action: '',
    onRemove: file => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: (file, fileList) => {
      setFileList(prevFileList => ([...prevFileList, file]));
      return false;
    },
    fileList

  }
  return (
    <div className='dragger-files'>
      <NavHeader />
      <header className="header">
        {/* <img src={logo} className="App-logo" alt="logo" /> */}
        <img src={logo} className="logo" alt="logo" />
        <Tooltip className='App-tooltip'>
          <span className='App-span'>BIGGERPIG </span>
        </Tooltip>
        <Tooltip className='App-tooltip'>
          <span className='App-span'>ABAP CRUD ANALYSIS </span>
        </Tooltip>
      </header>
      <Dragger {...uploadProps} className='dragger-area'>
        <UploadOutlined />
        &nbsp;&nbsp;
        Select upload files
      </Dragger>
      <Button
        type="primary"
        onClick={UploadFile}
        disabled={fileList.length === 0}
        loading={uploading}
        style={{ marginTop: 16, marginBottom: 16 }}
        className='upload-btn'
      >
        {uploading ? 'Uploading' : 'Start Upload'}
      </Button>
    </div>
  );
};